<template>
  <a-dropdown
    v-model:visible="visible"
    trigger="click"
    @visibleChange="visibleChange"
  >
    <template #overlay>
      <div class="lang-container-text" @click.prevent>
        <div class="search-box flex-between">
          <div class="flex-align-center">
            <svg aria-hidden="true" class="search-icon">
              <use xlink:href="#icon-xunzhao"></use>
            </svg>
            <a-input
              v-model:value="searchLang"
              placeholder="搜索语种名称"
              @change="changeFunc"
            />
          </div>
          <div class="flex-center">
            <div
              class="choose-history-item margin-l-10 flex-align-center"
              v-for="(item, key) in localArr.slice(0, 3)"
              :key="key"
              @click="chooseLang(item)"
              :class="
                item.languageId == disLang
                  ? 'dis-css'
                  : item.languageId == language
                    ? 'current-css'
                    : ''
              "
            >
              {{ item.languageName }}
            </div>
          </div>
        </div>
        <div class="display-flex" v-if="types.length > 0">
          <div
            v-for="(type, $i) in types"
            :key="$i"
            class="padding-l-20 padding-r-10"
          >
            <div class="e-title">{{ type }}</div>
            <div
              v-for="item in languageListHtml(languageList)"
              :key="item.languageId"
              :value="item.languageId"
            >
              <div
                v-if="type.includes(item.type)"
                class="lang-item"
                @click="chooseLang(item)"
                :class="
                  item.languageId == disLang
                    ? 'dis-css'
                    : item.languageId == language
                      ? 'current-css'
                      : ''
                "
              >
                {{ item.languageName }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center padding-t-50 color-999">暂无数据</div>
      </div>
    </template>
    <span
      class="cursor-pointer flex-align-center language-container user-select-none"
    >
      <span class="language-name-box">
        {{
          languageName ? languageName : type === 'img' ? '请选择' : '自动检测'
        }}
      </span>
      <DownOutlined class="margin-l-10" />
    </span>
  </a-dropdown>
</template>
<script>
  import { ref, reactive, toRefs, onMounted, computed, watch } from 'vue'
  import { getPinYinFirstCharacter } from '../../../../utils/convertToPinYin'
  import { DownOutlined } from '@ant-design/icons-vue'
  import { getDictionary } from '@/http/api'
  export default {
    props: {
      language: {
        default: undefined,
      },
      disLang: {
        default: undefined,
        type: [String, Number],
      },
      isPre: {
        default: false,
        type: Boolean,
      },
      size: {
        default: 'large',
        type: String,
      },
      type: {
        default: '',
      },
    },
    components: {
      DownOutlined,
    },
    setup(props, ctx) {
      const visible = ref(false)
      const state = reactive({
        languageName: '',
        searchLang: '',
        types: ['ABCDE', 'FGHIJ', 'KLMN', 'OPQRS', 'TUVWX', 'YZ'],
        languageList: JSON.parse(localStorage.getItem('languageInfoList')),
        localArr: JSON.parse(localStorage.getItem('_localArr')) || [],
      })

      // 初始化language
      const initLanguageList = () => {
        const languageInfoList = localStorage.getItem('languageInfoList')
        if (!languageInfoList) {
          getDictionary().then(({ data }) => {
            const _data = data.data
            state.languageList = _data.languageInfoList
            localStorage.industryTreeList = JSON.stringify(
              _data.industryTreeList
            )
            localStorage.languageInfoList = JSON.stringify(
              _data.languageInfoList
            )
            languageNameFunc(props.language)
          })
          return
        }
        languageNameFunc(props.language)
      }

      // 格式化language
      const languageListHtml = (_languageList) => {
        if (!_languageList) return
        return _languageList
          .filter((res) => !res.hide)
          .map((item) => {
            return Object.assign({}, item, {
              type:
                getPinYinFirstCharacter(item.languageName, '-', true).slice(
                  0,
                  1
                ) || 'Z',
            })
          })
      }

      // 选择语言
      const chooseLang = (item) => {
        const { languageId } = item
        if (languageId == props.disLang) return
        ctx.emit('change', languageId)
        languageNameFunc(languageId)
        visible.value = false
        const index = state.localArr.findIndex(
          (list) => list.languageId == languageId
        )
        if (index == -1) {
          state.localArr.unshift(item)
        } else {
          state.localArr.splice(index, 1)
          state.localArr.unshift(item)
        }
        localStorage.setItem('_localArr', JSON.stringify(state.localArr))
      }

      // 根据language获取languageName
      const languageNameFunc = (id) => {
        const _languageList = JSON.parse(
          localStorage.getItem('languageInfoList')
        )
        if (!_languageList) return
        for (let i = 0; i < _languageList.length; i++) {
          if (_languageList[i].languageId == id) {
            state.languageName = _languageList[i].languageName
            return
          }
        }
      }

      // 输入语言
      const changeFunc = () => {
        const d = languageListHtml(state.languageList)
        const _searchList = d.filter((item) =>
          item.languageName.includes(state.searchLang)
        )
        state.languageList = _searchList

        const _types = state.types.filter((item) =>
          item.includes(
            getPinYinFirstCharacter(state.searchLang, '-', true).slice(0, 1) ||
              'Z'
          )
        )
        state.types = _types
        if (_searchList.length === 0) {
          state.types = []
        }

        if (!state.searchLang) {
          state.languageList = JSON.parse(
            localStorage.getItem('languageInfoList')
          )
          state.types = ['ABCDE', 'FGHIJ', 'KLMN', 'OPQRS', 'TUVWX', 'YZ']
        }
      }

      const visibleChange = () => {
        state.localArr = JSON.parse(localStorage.getItem('_localArr')) || []
      }

      // 初始加载language
      onMounted(() => {
        initLanguageList()
      })

      // 监听 language 变化
      watch(
        () => props.language,
        () => {
          languageNameFunc(props.language)
        }
      )

      return {
        ...toRefs(state),
        visible,
        languageListHtml,
        chooseLang,
        languageNameFunc,
        changeFunc,
        visibleChange,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .language-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 12px;
    &:hover {
      background: #f2f3f5;
      border-radius: 6px;
    }
  }
  .lang-container-text {
    // width: 770px;
    // height: 486px;
    padding-bottom: 10px;
    background-color: #fff;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    border: 1px solid #f2f3f5;
    .e-title {
      color: #bbb;
      font-size: 12px;
      height: 40px;
      line-height: 40px;
      padding-bottom: 10px;
      padding-left: 5px;
    }
    .lang-item {
      padding: 5px 5px;
      color: #000000a6;
      cursor: pointer;
      &:hover {
        color: var(--primary-color);
        background-color: transparent;
      }
    }
    .dis-css {
      cursor: not-allowed;
      color: #999;
      &:hover {
        background-color: transparent;
        color: #999;
      }
    }
    .current-css {
      // font-weight: 600;
      // color: #000;
      // background-color: #ccc;
      color: var(--primary-color);
      &:hover {
        // background-color: rgba(215, 69, 144, 0.2);
        color: var(--primary-color);
      }
    }
  }
  .lang-btn {
    width: 200px;
  }
  .search-box {
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #f2f3f5;
    .search-icon {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      cursor: pointer;
    }
    :deep(.ant-input) {
      margin-left: 4px;
      border: none;
      outline: none;
      box-shadow: none;
    }
  }
  .choose-history-item {
    height: 32px;
    padding: 0 20px;
    background: #fdfdfd;
    border-radius: 20px;
    border: 1px solid #f2f3f5;
    cursor: pointer;
  }
  .user-select-none {
    user-select: none;
  }
</style>
